import { error } from "console";
import { QuestionaryQuestion } from "../models/QuestionaryQuestion";
import { Questionary } from "../models/Questionary";
import { QuestionaryDetail } from "../models/QuestionaryDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { PolicyType } from "../models/PolicyType";
import { QuestionaryQuestionInput } from "../models/QuestionaryQuestionInput";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getQuestions = async (
  subsectionId: number
): Promise<QuestionaryQuestion[]> => {
  const response = await fetch(
    `${API_BASE_URL}/QuestionaryQuestion/GetQuestions?subsectionId=${subsectionId}`
  );
  const data = await response.json();
  return data;
};

const insertQuestion = async (questionary: QuestionaryQuestionInput) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryQuestion/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(questionary),
  });

  return response;
};

const updateQuestion = async (question: QuestionaryQuestion) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryQuestion/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(question),
  });

  return response;
};

const linkQuestion = async (answerId: number, questionId: number) => {
  const obj = { answerId: answerId, questionId: questionId };

  const response = await fetch(`${API_BASE_URL}/QuestionaryQuestion/Link`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(obj),
  });

  return response;
};

const unlinkQuestion = async (answerId: number) => {
  const obj = { answerId: answerId, questionId: null };

  const response = await fetch(`${API_BASE_URL}/QuestionaryQuestion/Unlink`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(obj),
  });

  return response;
};

const deleteQuestion = async (question: QuestionaryQuestion) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryQuestion/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(question),
  });

  return response;
};

const updateQuestionPositions = async (
  positionUpdates: Array<{ questionId: number; newPosition: number }>
) => {
  const response = await fetch(
    `${API_BASE_URL}/QuestionaryQuestion/UpdatePositions`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset= utf-8" },
      body: JSON.stringify(positionUpdates),
    }
  );

  return response;
};

const QuestionaryQuestionService = {
  getQuestions,
  insertQuestion,
  updateQuestion,
  linkQuestion,
  unlinkQuestion,
  deleteQuestion,
  updateQuestionPositions,
};

export default QuestionaryQuestionService;
